import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
      {items.map((item, idx) => {
        const isLast = idx === items.length - 1;
        return (
          <span key={`${item.label}-${idx}`} className="flex items-center gap-1">
            {item.to && !isLast ? (
              <Link to={item.to} className="hover:text-primary-700 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "text-foreground-800 whitespace-nowrap" : "whitespace-nowrap"}>
                {item.label}
              </span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-foreground-400" />}
          </span>
        );
      })}
    </nav>
  );
}